import {IMenuEntity} from "@/model/menu/IMenuEntity";
import {IMenuRouteInfo} from "@/model/menu/IMenuRouteInfo";

export interface IMenuConfig {
  menus: IMenuEntity[];
  sharedMenus: IMenuEntity[];
  routes: IMenuRouteInfo[];
}

export const mainItemsOrder: { [title: string]: number } = {
  'Центральная панель': 1,
  'Заявки': 2,
  'Обходчик контролер': 3,
  'Анализ режимов': 4,
  'Анализ балансов': 5,
  'Поддержка эксплуатации': 6,
  'Потребители': 7,
  'Справочники': 8,
  'Администрирование': 9,
  'Настройки': 10,
};
